import { InjectionToken, Provider } from '@angular/core';
import { OUTLAW_ROUTES } from '@outlaw/core';

export enum CommunityRoutes {
  home = 'home',
  post = 'post',
  subscribe = 'subscribe',
  editPost = 'editPost',
  profile = 'profile',
}

export type CommunityRoutesConfig = {
  [CommunityRoutes.home]?: string;
  [CommunityRoutes.post]?: string;
  [CommunityRoutes.subscribe]?: string;
  [CommunityRoutes.editPost]?: string;
  [CommunityRoutes.profile]?: string;
};

export const DEFAULT_COMMUNITY_ROUTES: Required<CommunityRoutesConfig> = {
  [CommunityRoutes.home]: '/',
  [CommunityRoutes.post]: OUTLAW_ROUTES.post,
  [CommunityRoutes.subscribe]: OUTLAW_ROUTES.subscribe,
  [CommunityRoutes.editPost]: '/channel/edit-post',
  [CommunityRoutes.profile]: OUTLAW_ROUTES.profile,
};

export function provideCommunityRoutes(routes: CommunityRoutesConfig = {}): Provider[] {
  const mergedRoutes: Required<CommunityRoutesConfig> = {
    ...DEFAULT_COMMUNITY_ROUTES,
    ...routes,
  };

  return [
    {
      provide: OUTLAW_COMMUNITY_ROUTES,
      useValue: mergedRoutes,
    },
  ];
}

export const OUTLAW_COMMUNITY_ROUTES = new InjectionToken<Required<CommunityRoutesConfig>>('OUTLAW_COMMUNITY_ROUTES');
